import React, { Component } from 'react';
import styles from '../../style/style';
import Logo from '../../static/img/logo-white.svg';
import Location from '../../static/img/location.svg';
import Search from '../../components/search';
import fetch from 'isomorphic-unfetch';
import Loading from '../../components/loading';
//import ReactGA from 'react-ga';
//import { hotjar } from 'react-hotjar';
import {withRouter} from "react-router-dom";
import ModalTrigger from '../../components/modaltrigger';
import { auth } from '../../firebase.js';
import Footer from '../../components/footer';
// import Alert from '../../components/alert';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  componentDidMount() {
    document.title = `Dwellist - Look up any property for free`;
    if (process.env.NODE_ENV === 'production') {
      //ReactGA.initialize('UA-111872677-1');
      //ReactGA.pageview(window.location.pathname);
      //hotjar.initialize(761201);
    }
    
    auth.onAuthStateChanged(function(user) {
      if (user) {
        this.setState({
          loggedIn: true
        })
      } else {
        this.setState({
          loggedIn: false
        })
      }
    }.bind(this));
    
    this.props.ipAddress && (
    fetch(`//freegeoip.net/json/${this.props.ipAddress}`)
      .then((response) => {
        if (!response.ok) { throw response }
        return response.json()  //we only get here if there is no error
      })
      .then((json) => {
        this.setState({
          ipAddress: json
        })
      })
    )
  }

  isLoading = (value) => {
    this.setState({
      loading: value
    })
  }

  logout = () => {
    auth.signOut();
  }

  render() {
    return (
      <div>
      <div className="hero"
        style={{
          background: "linear-gradient(blue 0%, #00b8ff 100%)",
          color: styles.colors.inverse,
          padding: styles.padding,
          minHeight: "100vh"
        }}
      >
        <nav style={{
          maxWidth: "1100px",
          margin: "auto",
          paddingBottom: "8px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <img
            src={Logo}
            style={{
              width: "120px"
            }}
          />
          {/** this.state.loggedIn ?
            <button style={styles.lightButton} onClick={ this.logout }>Sign out</button> :
            <ModalTrigger buttonStyle={styles.lightButton}>
                Sign up
            </ModalTrigger>
          **/}
        </nav>
        <div style={{
          maxWidth: "100%",
          display: "flex",
          justifyContent: "center",
        }}>
          
            <h1
              style={{
                marginTop: "6rem",
                fontWeight: 700,
                marginBottom: "0"
              }}
            >
              Look up any Irish address 
            </h1>
        </div>
        <div  style={{
          width: "600px",
          margin: "auto",
          maxWidth: "100%"
        }} >
        <p style={{
              marginBottom: "2rem",
              marginTop: "0.5rem",
              maxWidth: "100%",
              display: "flex",
              justifyContent: "center",
            }}>
            Get an instant report on any property in Ireland.
        </p>
          <Search
            client={this.state.ipAddress}
            defaultValue="Grafton Street, Dublin"
            style={{
              flex: "1"
            }}
            isLoading={this.isLoading}
          />
        </div>
        <div style={{
          height: "100px"
        }}>
          { this.state.loading &&
              <Loading
                fill="white"
                height="12px"
                width="12px"
                container={true}
              />
          }
        </div>
        <div style={{
          width: "600px",
          margin: "3rem auto",
          maxWidth: "100%",
         }}>
          {/**<Alert emoji={"💡"} background="rgba(255,255,255,0.1)">
            <strong>Tip:</strong> Paste a link from a property website and we'll find the address for you!
        </Alert>**/}
        </div>
      </div>
      <Footer />
    </div>)
  }
}

export default withRouter(Home);


// WEBPACK FOOTER //
// ./src/pages/home/index.js